


<!-- <div *ngIf="BarcodeValue" class="barcode">
<div class="bar" *ngFor="let bar of getBars(BarcodeValue)"></div>
</div> -->
@if (showPreviewButton) {
  <div   style="display: contents;">
    <div class="BarcodeClass" id="BarcodeId" #barcodeContainer>
    <img class="backimage" style="margin-left: 2%;
    width: 3%;" [src]="'/assets/images/barcode-print-icon.png'"/>
      </div>
      @if (showPreviewButton) {
        <button   kendoButton
          (click)="previewBarcode()"
          >
          <span><img
            class="backimage"
            [src]="'/assets/menu/'+ _theme +'/print-icon.svg'"
          /></span></button>
        }
        <!-- <button  *ngIf="showPreviewButton" (click)="previewBarcode()" kendoButton class="steps_buttons_class">
        <span><img class="backimage" [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span>
      </button> -->
      <div>
      </div>
      @if (_previewBarcodeWindow) {
        <kendo-window (close)="_closeForm()">
          <report-viewer [barcodeModel]="barcodeModel"
            [windowMode]="windowMode"
            [previewMode]="previewMode"
            (closeForm)="_closeForm()"
            >
          </report-viewer>
        </kendo-window>
      }
      <!-- <report-viewer *ngIf="viewBarcode"  [barcodeModel]="barcodeModel" [previewMode]="true"></report-viewer> -->
    </div>
  }
  @if (_previewBarcodeWindow) {
    <div class="k-overlay">
    </div>
  }
